export const TICKET_STATUSES = ['open', 'in_progress', 'resolved', 'closed'] as const;
export type TicketStatus = (typeof TICKET_STATUSES)[number];

export function isOrgAdminRole(role: string | null | undefined): boolean {
  return role === 'owner' || role === 'admin';
}

/** Sem responsável: todos. Com responsável: só o atribuído + owner/admin. */
export function canReceiveAssignedNotification(
  assignedTo: string | null | undefined,
  userId: string | null | undefined,
  role?: string | null,
): boolean {
  if (isOrgAdminRole(role)) return true;
  if (!assignedTo) return true;
  return Boolean(userId && userId === assignedTo);
}

export function canCustomerReply(status: TicketStatus): boolean {
  return status !== 'closed';
}
